<!-- FILTRO ESCOLA -->

<form [formGroup]="formFilter"
      (submit)="onSubmit()"
      aria-labelledby="filtro-title">
  <section [ngClass]="{
      'section-filtro': style === 1 && !dividir2filas,
      'section-filtro-menor': style === 2,
      'section-filtro-tres-inputs': style === 3,
      'section-filtro-pec': template === TemplateFiltroPadrao.HomePEC,
      'section-filtro-relatorio-pec': template === TemplateFiltroPadrao.PEC && !dividir2filas,
      'section-filtro-pec-2filas': dividir2filas
    }"
           aria-labelledby="filtro-section-title">
    <div class="container">
      @if(template == TemplateFiltroPadrao.Default){

      <div class="grupo-filter">
        <p><b>URE</b></p>
        <ng-select [items]="diretorias"
                   bindLabel="nomeDiretoria"
                   bindValue="codigoDiretoria"
                   placeholder="Selecione uma URE"
                   formControlName="codigoDiretoria"
                   name="codigoDiretoria"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoDiretoria.errors }"
                   (change)="getEscolas(form.codigoDiretoria.value)"
                   [attr.title]="getLabelDiretoria()"
                   aria-describedby="diretoria-error">
        </ng-select>
        <div *ngIf="submitted && form.codigoDiretoria.errors"
             id="diretoria-error"
             class="alert">
          <div *ngIf="form.codigoDiretoria.errors.required">
            * URE é obrigatório
          </div>
        </div>

        @if(atividadeDE) {
        <div class="grupo-filter-ano grupo-filter-somente-diretoria">
          <p><b>Atividade na URE</b></p>
          <label>
            <input type="checkbox" [checked]="this.atividadeDiretoria" class="checkbox" (click)="OnChangeApenasDiretoria()" /><i></i>
          </label>
        </div>
        }
      </div>

      <div class="grupo-filter">
        <p><b>Escola</b></p>
        <ng-select [items]="escolas"
                   bindLabel="nomeEscola"
                   bindValue="codigoEscola"
                   placeholder="Selecione uma Escola"
                   formControlName="codigoEscola"
                   name="codigoEscola"
                   (change)="getTurnos()"
                   [clearable]="!isGestorEscolar()"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoEscola.errors }"
                   aria-describedby="escolas-error">
        </ng-select>
        <div *ngIf="submitted && form.codigoEscola.errors" id="escolas-error" class="alert">
          <div *ngIf="form.codigoEscola.errors.required">
            * Escola é obrigatório
          </div>
        </div>

        @if(psiInativos) {
        <div class="grupo-filter-ano">
          <p><b>Psicólogos Inativos</b></p>
          <label>
            <input type="checkbox" [checked]="this.psicologosInativos" class="checkbox" (click)="OnChangePsicologosInativos()" /><i></i>
          </label>
        </div>
        }
      </div>

      <div class="grupo-filter">
        <p><b>Turno</b></p>
        <ng-select [items]="turnos"
                   bindLabel="nomeTurno"
                   bindValue="codigoTurno"
                   placeholder="Selecione um Turno"
                   formControlName="codigoTurno"
                   name="codigoTurno"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoTurno.errors }"
                   (change)="getTurmas(form.codigoEscola.value, form.codigoTurno.value)"
                   aria-describedby="turno-error">
        </ng-select>
        <div *ngIf="submitted && form.codigoTurno.errors"
             id="escola-error"
             class="alert"
             aria-live="polite">
          <div *ngIf="form.codigoTurno.errors.required">
            * Turno é obrigatório
          </div>
        </div>
      </div>

      <div class="grupo-filter">
        <p><b>Turma</b></p>
        <ng-select [items]="turmas"
                   bindLabel="descricaoTurma"
                   bindValue="codigoTurma"
                   placeholder="Selecione uma Turma"
                   formControlName="codigoTurma"
                   name="codigoTurma"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoTurma.errors }"
                   aria-describedby="turma-error">
        </ng-select>
        <div *ngIf="submitted && form.codigoTurma.errors"
             id="turno-error"
             class="alert"
             aria-live="polite">
          <div *ngIf="form.codigoTurma.errors.required"></div>
        </div>
      </div>

      <div class="grupo-filter-ano">
        <p><b>Ano</b></p>
        <ng-select [items]="anos"
                   placeholder="Selecione o Ano"
                   formControlName="anoAtual"
                   name="anoAtual"
                   [ngClass]="{ 'is-invalid': submitted && form.anoAtual.errors }">
        </ng-select>
        <div *ngIf="submitted && form.anoAtual.errors" class="alert">
          <div *ngIf="form.anoAtual.errors.required">
            Ano é um campo obrigatório
          </div>
        </div>
      </div>

      } @else if(template == TemplateFiltroPadrao.Polo){

      <div class="grupo-filter-polo">
        <p><b>Polo</b></p>
        <ng-select [items]="polos"
                   bindLabel="descricaoPolo"
                   bindValue="codigoPolo"
                   placeholder="Selecione um Polo"
                   name="codigoPolo"
                   formControlName="codigoPolo"
                   (change)="OnChangePolo()"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoPolo.errors }"
                   aria-describedby="polo-error">
        </ng-select>

        <div *ngIf="submitted && form.codigoPolo.errors"
             id="polo-error"
             class="alert"
             aria-live="polite">
          <div *ngIf="form.codigoPolo.errors.required">
            * Polo é obrigatório
          </div>
        </div>
      </div>

      <div class="grupo-filter-polo">
        <p><b>URE</b></p>
        <ng-select [items]="diretorias"
                   bindLabel="nomeDiretoria"
                   bindValue="codigoDiretoria"
                   placeholder="Selecione uma URE"
                   formControlName="codigoDiretoria"
                   name="codigoDiretoria"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoDiretoria.errors }"
                   (change)="onChangeDiretoriaPolo()"
                   [attr.title]="getLabelDiretoria()"
                   aria-describedby="diretorias-polo-error">
        </ng-select>
        <div *ngIf="submitted && form.codigoDiretoria.errors"
             id="diretorias-polo-error"
             class="alert"
             aria-live="polite">
          <div *ngIf="form.codigoDiretoria.errors.required">
            * URE é obrigatório
          </div>
        </div>

        @if(atividadeDE) {
        <div class="grupo-filter-ano">
          <p><b>Atividade na URE</b></p>
          <label>
            <input type="checkbox"
                   [checked]="this.atividadeDiretoria"
                   class="checkbox"
                   (click)="OnChangeApenasDiretoria()" /><i></i>
          </label>
        </div>
        }
      </div>

      <div class="grupo-filter-polo">
        <p><b>Escola</b></p>
        <ng-select [items]="escolas"
                   bindLabel="nomeEscola"
                   bindValue="codigoEscola"
                   placeholder="Selecione uma Escola"
                   formControlName="codigoEscola"
                   name="codigoEscola"
                   (change)="getTurnos()"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoEscola.errors }"
                   aria-describedby="escolas-polo-error">
        </ng-select>
        <div *ngIf="submitted && form.codigoEscola.errors" id="escolas-polo-error" class="alert" aria-live="polite">
          <div *ngIf="form.codigoEscola.errors.required">
            * Escola é obrigatório
          </div>
        </div>

        @if(psiInativos) {
        <div class="grupo-filter-ano">
          <p><b>Psicólogos Inativos</b></p>
          <label>
            <input type="checkbox" [checked]="this.psicologosInativos" class="checkbox" (click)="OnChangePsicologosInativos()" /><i></i>
          </label>
        </div>
        }

      </div>
      } @else if(template == TemplateFiltroPadrao.PEC){
      @if(dividir2filas) {
      <!-- Primeira fila: Polo/URE/Município/Escola -->
      <div class="filtro-linha filtro-linha-principal">
        @if(usePolo) {
        <div class="grupo-filter grupo-filter-polo">
          <p><b>Polo</b></p>
          <ng-select [items]="polos" bindLabel="descricaoPolo" bindValue="codigoPolo" placeholder="Selecione um Polo"
                     name="codigoPolo" formControlName="codigoPolo" (change)="OnChangePolo()"
                     appendTo="body"
                     [ngClass]="{ 'is-invalid': submitted && form.codigoPolo.errors }" aria-describedby="polo-error">
          </ng-select>

          <div *ngIf="submitted && form.codigoPolo.errors" id="polo-error" class="alert" aria-live="polite">
            <div *ngIf="form.codigoPolo.errors.required">
              * Polo é obrigatório
            </div>
          </div>
        </div>
        }
        <div class="grupo-filter grupo-filter-diretoria">
          <p><b>URE</b></p>
          <ng-select [items]="diretorias" bindLabel="nomeDiretoria" bindValue="codigoDiretoria"
                     placeholder="Selecione uma URE" formControlName="codigoDiretoria" name="codigoDiretoria"
                     appendTo="body"
                     [ngClass]="{ 'is-invalid': submitted && form.codigoDiretoria.errors }"
                     (change)="usePolo ? getEscolas(form.codigoDiretoria.value) : OnChangeDiretoriaHomePEC(form.codigoDiretoria.value)"
                     [attr.title]="getLabelDiretoria()"
                     aria-describedby="diretorias-polo-error">
          </ng-select>
          <div *ngIf="submitted && form.codigoDiretoria.errors" id="diretorias-polo-error" class="alert"
               aria-live="polite">
            <div *ngIf="form.codigoDiretoria.errors.required">
              * URE é obrigatório
            </div>
          </div>

          @if(atividadeDE) {
          <div class="grupo-filter-ano">
            <p><b>Atividade na URE</b></p>
            <label>
              <input type="checkbox" [checked]="this.atividadeDiretoria" class="checkbox"
                     (click)="OnChangeApenasDiretoria()" /><i></i>
            </label>
          </div>
          }
        </div>

        @if(!usePolo) {
        <div class="grupo-filter grupo-filter-municipio">
          <p><b>Município</b></p>
          <ng-select [items]="municipios"
                     bindLabel="nomeMunicipio"
                     bindValue="codigoMunicipio"
                     placeholder="Selecione um Município"
                     formControlName="codigoMunicipio"
                     name="codigoMunicipio"
                     appendTo="body"
                     (change)="OnChangeMunicipio()">
          </ng-select>
        </div>
        }

        <div class="grupo-filter grupo-filter-escola">
          <p><b>Escola</b></p>
          <ng-select [items]="escolas" bindLabel="nomeEscola" bindValue="codigoEscola" placeholder="Selecione uma Escola"
                     formControlName="codigoEscola" name="codigoEscola" (change)="activeCiclos(form.codigoDiretoria.value, form.codigoEscola.value, false)"
                     appendTo="body"
                     [ngClass]="{ 'is-invalid': submitted && form.codigoEscola.errors }" aria-describedby="escolas-polo-error">
          </ng-select>
          <div *ngIf="submitted && form.codigoEscola.errors" id="escolas-polo-error" class="alert" aria-live="polite">
            <div *ngIf="form.codigoEscola.errors.required">
              * Escola é obrigatório
            </div>
          </div>
        </div>
      </div>

      <!-- Segunda fila: Demais campos -->
      <div class="filtro-linha filtro-linha-secundaria">

        @if(listarPOC) {
        <div class="grupo-filter grupo-filter-poc">
          <p><b>POC</b></p>
          <ng-select [items]="listaPOC" bindLabel="nome" bindValue="cpf" placeholder="Selecione um POC"
                     formControlName="codigoPOC" name="codigoPOC" appendTo="body"
                     [loading]="carregandoPOC"
                     [ngClass]="{ 'is-invalid': submitted && form.codigoPOC.errors }"
                     aria-describedby="poc-error">
          </ng-select>
        </div>
        }

        @if(listarPsicologo) {

        <div class="grupo-filter">
          <p><b>Psicólogo</b></p>
          <ng-select [items]="lstPsicologos"
                     bindLabel="nomePsicologoCompleto"
                     bindValue="codigoCPF"
                     placeholder="Selecione um Psicologo"
                     formControlName="codigoCPF"
                     name="codigoCPF"
                     appendTo="body"
                     [ngClass]="{ 'is-invalid': submitted && form.codigoCPF.errors }"
                     aria-describedby="turma-error">
          </ng-select>
        </div>

        }

        <div class="grupo-filter grupo-filter-ciclo">
          <p><b>Ciclo</b></p>
          <ng-select [items]="tipoEnsinos"
                     bindLabel="nomeTipoEnsino"
                     bindValue="codigoTipoEnsino"
                     [placeholder]="carregandoCiclos ? 'Carregando ciclos...' : 'Selecione um Ciclo'"
                     formControlName="codigoTipoEnsino"
                     name="codigoTipoEnsino"
                     appendTo="body"
                     [loading]="carregandoCiclos"
                     [ngClass]="{ 'is-invalid': submitted && form.codigoTipoEnsino.errors }"
                     aria-describedby="turma-error">
          </ng-select>
          <!-- <div
            *ngIf="submitted && form.codigoTipoEnsino.errors"
            id="turno-error"
            class="alert"
            aria-live="polite"
          >
            <div *ngIf="form.codigoTipoEnsino.errors.required"></div>
          </div> -->
        </div>

        <!-- <div class="grupo-filter grupo-filter-turno">
          <p><b>Turno</b></p>
          <ng-select
            [items]="turnos"
            bindLabel="nomeTurno"
            bindValue="codigoTurno"
            placeholder="Selecione um Turno"
            formControlName="codigoTurno"
            name="codigoTurno"
            (change)="getTurmas(form.codigoEscola.value, form.codigoTurno.value)"
          >
          </ng-select>
        </div> -->
        @if(usePeriodo) {

        <div class="grupo-filter grupo-filter-fp">
          <div class="fp-periodo-poc">
            <div class="input-data">
              <label for="fpDataInicio"><p><b>Data início</b></p></label>
              <input class="input-filtro-periodo" id="fpDataInicio" type="date" formControlName="fpDataInicio" />
            </div>
          </div>
        </div>
        <div class="grupo-filter grupo-filter-fp">
          <div class="fp-periodo-poc">
            <div class="input-data">
              <label for="fpDataFim"><p><b>Data fim</b></p></label>
              <input class="input-filtro-periodo" id="fpDataFim" type="date" formControlName="fpDataFim" />
            </div>
          </div>
        </div>

        }

        @if(useAno) {

        <div class="grupo-filter-ano">
          <p><b>Ano</b></p>
          <ng-select [items]="anos"
                     placeholder="Selecione o Ano"
                     formControlName="anoAtual"
                     name="anoAtual"
                     appendTo="body"
                     [ngClass]="{ 'is-invalid': submitted && form.anoAtual.errors }">
          </ng-select>
          <div *ngIf="submitted && form.anoAtual.errors" class="alert">
            <div *ngIf="form.anoAtual.errors.required">
              Ano é um campo obrigatório
            </div>
          </div>
        </div>

        }

        <!-- Botão de pesquisa na segunda fila -->
        <div class="btn-search-wrapper">
          <div class="grupo-filter-button">
            <button type="submit"
                    class="btn-search-filtro"
                    id="btn-search-chamado"
                    aria-label="Pesquisar">
              <i class="fa-solid fa-magnifying-glass icon-white"></i>
              <span>Pesquisar</span>
            </button>
          </div>
        </div>
      </div>

      } @else {
      <!-- Layout original (sem dividir em 2 filas) -->
      @if(usePolo) {
      <div class="grupo-filter grupo-filter-polo">
        <p><b>Polo</b></p>
        <ng-select [items]="polos" bindLabel="descricaoPolo" bindValue="codigoPolo" placeholder="Selecione um Polo"
                   name="codigoPolo" formControlName="codigoPolo" (change)="OnChangePolo()"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoPolo.errors }" aria-describedby="polo-error">
        </ng-select>

        <div *ngIf="submitted && form.codigoPolo.errors" id="polo-error" class="alert" aria-live="polite">
          <div *ngIf="form.codigoPolo.errors.required">
            * Polo é obrigatório
          </div>
        </div>
      </div>
      }
      <div class="grupo-filter grupo-filter-diretoria">
        <p><b>URE</b></p>
        <ng-select [items]="diretorias" bindLabel="nomeDiretoria" bindValue="codigoDiretoria"
                   placeholder="Selecione uma URE" formControlName="codigoDiretoria" name="codigoDiretoria"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoDiretoria.errors }"
                   (change)="OnChangeDiretoriaHomePEC(form.codigoDiretoria.value)" [attr.title]="getLabelDiretoria()"
                   aria-describedby="diretorias-polo-error">
        </ng-select>
        <div *ngIf="submitted && form.codigoDiretoria.errors" id="diretorias-polo-error" class="alert"
             aria-live="polite">
          <div *ngIf="form.codigoDiretoria.errors.required">
            * URE é obrigatório
          </div>
        </div>

        @if(atividadeDE) {
        <div class="grupo-filter-ano">
          <p><b>Atividade na URE</b></p>
          <label>
            <input type="checkbox" [checked]="this.atividadeDiretoria" class="checkbox"
                   (click)="OnChangeApenasDiretoria()" /><i></i>
          </label>
        </div>
        }
      </div>

      <div class="grupo-filter grupo-filter-municipio">
        <p><b>Município</b></p>
        <ng-select [items]="municipios"
                   bindLabel="nomeMunicipio"
                   bindValue="codigoMunicipio"
                   placeholder="Selecione um Município"
                   formControlName="codigoMunicipio"
                   name="codigoMunicipio"
                   (change)="OnChangeMunicipio()">
        </ng-select>
      </div>

      <div class="grupo-filter  grupo-filter-escola">
        <p><b>Escola</b></p>
        <ng-select [items]="escolas" bindLabel="nomeEscola" bindValue="codigoEscola" placeholder="Selecione uma Escola"
                   formControlName="codigoEscola" name="codigoEscola" (change)="activeCiclos(form.codigoDiretoria.value, form.codigoEscola.value, false)"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoEscola.errors }" aria-describedby="escolas-polo-error">
        </ng-select>
        <div *ngIf="submitted && form.codigoEscola.errors" id="escolas-polo-error" class="alert" aria-live="polite">
          <div *ngIf="form.codigoEscola.errors.required">
            * Escola é obrigatório
          </div>
        </div>
      </div>

      @if(listarPOC) {
      <div class="grupo-filter .grupo-filter-poc">
        <p><b>POC</b></p>
        <ng-select [items]="listaPOC" bindLabel="nome" bindValue="cpf" placeholder="Selecione um POC"
                   formControlName="codigoPOC" name="codigoPOC" [ngClass]="{ 'is-invalid': submitted && form.codigoPOC.errors }"
                   aria-describedby="poc-error">
        </ng-select>
      </div>
      }

      @if(listarPsicologo) {

      <div class="grupo-filter">
        <p><b>Psicólogo</b></p>
        <ng-select [items]="lstPsicologos"
                   bindLabel="nomePsicologoCompleto"
                   bindValue="codigoCPF"
                   placeholder="Selecione um Psicologo"
                   formControlName="codigoCPF"
                   name="codigoCPF"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoCPF.errors }"
                   aria-describedby="turma-error">
        </ng-select>
      </div>

      }

      <div class="grupo-filter">
        <p><b>Ciclo</b></p>
        <ng-select [items]="tipoEnsinos"
                   bindLabel="nomeTipoEnsino"
                   bindValue="codigoTipoEnsino"
                   [placeholder]="carregandoCiclos ? 'Carregando ciclos...' : 'Selecione um Ciclo'"
                   formControlName="codigoTipoEnsino"
                   name="codigoTipoEnsino"
                   [loading]="carregandoCiclos"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoTipoEnsino.errors }"
                   aria-describedby="turma-error">
        </ng-select>
      </div>

      @if(usePeriodo) {

      <div class="grupo-filter grupo-filter-fp">
        <div class="fp-periodo-poc">
          <div class="input-data">
            <label for="fpDataInicio"><p><b>Data início</b></p></label>
            <input class="input-filtro-periodo" id="fpDataInicio" type="date" formControlName="fpDataInicio" />
          </div>
        </div>
      </div>
      <div class="grupo-filter grupo-filter-fp">
        <div class="fp-periodo-poc">
          <div class="input-data">
            <label for="fpDataFim"><p><b>Data fim</b></p></label>
            <input class="input-filtro-periodo" id="fpDataFim" type="date" formControlName="fpDataFim" />
          </div>
        </div>
      </div>

      }

      @if(useAno) {

      <div class="grupo-filter-ano">
        <p><b>Ano</b></p>
        <ng-select [items]="anos"
                   placeholder="Selecione o Ano"
                   formControlName="anoAtual"
                   name="anoAtual"
                   [ngClass]="{ 'is-invalid': submitted && form.anoAtual.errors }">
        </ng-select>
        <div *ngIf="submitted && form.anoAtual.errors" class="alert">
          <div *ngIf="form.anoAtual.errors.required">
            Ano é um campo obrigatório
          </div>
        </div>
      </div>

      }

      <div class="btn-search-wrapper">
        <div class="grupo-filter-button">
          <button type="submit"
                  class="btn-search-filtro"
                  id="btn-search-relatorio-pec"
                  aria-label="Pesquisar">
            <i class="fa-solid fa-magnifying-glass icon-white"></i>
            <span>Pesquisar</span>
          </button>
        </div>
      </div>
      }

      }
      @else if(template == TemplateFiltroPadrao.HomePEC){
      <div class="grupo-filter grupo-filter-polo">
        <p><b>Polo</b></p>
        <ng-select [items]="polos" bindLabel="descricaoPolo" bindValue="codigoPolo" placeholder="Selecione um Polo"
                   name="codigoPolo" formControlName="codigoPolo" (change)="OnChangePolo()"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoPolo.errors }" aria-describedby="polo-error">
        </ng-select>

        <div *ngIf="submitted && form.codigoPolo.errors" id="polo-error" class="alert" aria-live="polite">
          <div *ngIf="form.codigoPolo.errors.required">
            * Polo é obrigatório
          </div>
        </div>
      </div>

      <div class="grupo-filter grupo-filter-diretoria">
        <p><b>URE</b></p>
        <ng-select [items]="diretorias" bindLabel="nomeDiretoria" bindValue="codigoDiretoria"
                   placeholder="Selecione uma URE" formControlName="codigoDiretoria" name="codigoDiretoria"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoDiretoria.errors }"
                   (change)="OnChangeDiretoriaHomePEC(form.codigoDiretoria.value)" [attr.title]="getLabelDiretoria()"
                   aria-describedby="diretorias-polo-error">
        </ng-select>
        <div *ngIf="submitted && form.codigoDiretoria.errors" id="diretorias-polo-error" class="alert"
             aria-live="polite">
          <div *ngIf="form.codigoDiretoria.errors.required">
            * URE é obrigatório
          </div>
        </div>

        @if(atividadeDE) {
        <div class="grupo-filter-ano">
          <p><b>Atividade na URE</b></p>
          <label>
            <input type="checkbox" [checked]="this.atividadeDiretoria" class="checkbox"
                   (click)="OnChangeApenasDiretoria()" /><i></i>
          </label>
        </div>
        }
      </div>

      <div class="grupo-filter grupo-filter-municipio">
        <p><b>Município</b></p>
        <ng-select [items]="municipios"
                   bindLabel="nomeMunicipio"
                   bindValue="codigoMunicipio"
                   placeholder="Selecione um Município"
                   formControlName="codigoMunicipio"
                   name="codigoMunicipio"
                   (change)="OnChangeMunicipio()">
        </ng-select>
      </div>

      <div class="grupo-filter  grupo-filter-escola">
        <p><b>Escola</b></p>
        <ng-select [items]="escolas" bindLabel="nomeEscola" bindValue="codigoEscola" placeholder="Selecione uma Escola"
                   formControlName="codigoEscola" name="codigoEscola" (change)="activeCiclos(form.codigoDiretoria.value, form.codigoEscola.value, false)"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoEscola.errors }" aria-describedby="escolas-polo-error">
        </ng-select>
        <div *ngIf="submitted && form.codigoEscola.errors" id="escolas-polo-error" class="alert" aria-live="polite">
          <div *ngIf="form.codigoEscola.errors.required">
            * Escola é obrigatório
          </div>
        </div>
      </div>

      @if(listarPOC) {
      <div class="grupo-filter .grupo-filter-poc">
        <p><b>POC</b></p>
        <ng-select [items]="listaPOC" bindLabel="nome" bindValue="cpf" placeholder="Selecione um POC"
                   formControlName="codigoPOC" name="codigoPOC" [ngClass]="{ 'is-invalid': submitted && form.codigoPOC.errors }"
                   aria-describedby="poc-error">
        </ng-select>
      </div>
      }

      <div class="grupo-filter grupo-filter-ciclo">
        <p><b>Ciclo</b></p>
        <ng-select [items]="tipoEnsinos"
                   bindLabel="nomeTipoEnsino"
                   bindValue="codigoTipoEnsino"
                   [placeholder]="carregandoCiclos ? 'Carregando ciclos...' : 'Selecione um Ciclo'"
                   formControlName="codigoTipoEnsino"
                   name="codigoTipoEnsino"
                   [loading]="carregandoCiclos"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoTipoEnsino.errors }"
                   (change)="getTurnos()"
                   aria-describedby="turma-error">
        </ng-select>
        <!-- <div
          *ngIf="submitted && form.codigoTipoEnsino.errors"
          id="turno-error"
          class="alert"
          aria-live="polite"
        >
          <div *ngIf="form.codigoTipoEnsino.errors.required"></div>
        </div> -->
      </div>

      <div class="grupo-filter grupo-filter-turno">
        <p><b>Turno</b></p>
        <ng-select [items]="turnos"
                   bindLabel="nomeTurno"
                   bindValue="codigoTurno"
                   placeholder="Selecione um Turno"
                   formControlName="codigoTurno"
                   name="codigoTurno"
                   (change)="getTurmas(form.codigoEscola.value, form.codigoTurno.value)">
        </ng-select>
      </div>

      }

      @if(useAno) {

      <div class="grupo-filter-ano">
        <p><b>Ano</b></p>
        <ng-select [items]="anos"
                   placeholder="Selecione o Ano"
                   formControlName="anoAtual"
                   name="anoAtual"
                   [ngClass]="{ 'is-invalid': submitted && form.anoAtual.errors }">
        </ng-select>
        <div *ngIf="submitted && form.anoAtual.errors" class="alert">
          <div *ngIf="form.anoAtual.errors.required">
            Ano é um campo obrigatório
          </div>
        </div>
      </div>

      }

      @if(!dividir2filas) {
      <div class="btn-search-wrapper">
        <!-- <button
          type="submit"
          class="btn-search-filtro"
          id="btn-search-chamado"
          aria-label="Pesquisar"
        >
          <img src="../../../assets/img/icons/icon-search.svg" alt="Pesquisar" title="Pesquisar" />
        </button> -->
        <div class="grupo-filter-button">
          <button type="submit"
                  class="btn-search-filtro"
                  id="btn-search-chamado"
                  aria-label="Pesquisar">
            <i class="fa-solid fa-magnifying-glass icon-white"></i>
            <span>Pesquisar</span>
          </button>
        </div>

      </div>
      }

    </div>
  </section>
</form>

